import { Component } from 'preact'

export default class Weekday extends Component {
    shouldComponentUpdate(nextProps) {
        return this.props !== nextProps
    }

    render() {
        const { weekday, className, weekdaysLong, weekdaysShort, localeUtils, locale } = this.props
        let title
        if (weekdaysLong) {
            title = weekdaysLong[weekday]
        } else {
            title = localeUtils.formatWeekdayLong(weekday, locale)
        }
        let content
        if (weekdaysShort) {
            content = weekdaysShort[weekday]
        } else {
            content = localeUtils.formatWeekdayShort(weekday, locale)
        }

        return (
            <div className={className} role="columnheader">
                <abbr title={title}>{content}</abbr>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Datepicker/Weekday.js